// // export default EmiDueReport;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";

// import "./EmiDueReportTest.css";

// const EmiDueReportTest = () => {
//   const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//   const [emis, setEmis] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [filter, setFilter] = useState("pending"); // default filter

//   const baseUrl = "https://payyug.in/api/loan-emi";

//   const apiUrls = {
//     pending: `${baseUrl}/overdue?superAdminId=${superAdminId}`,
//     today: `${baseUrl}/today?superAdminId=${superAdminId}`,
//     upcoming: `${baseUrl}/upcoming7days?superAdminId=${superAdminId}`,
//   };

//   useEffect(() => {
//     const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

//     const fetchEmis = async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(apiUrls[filter]);
//         setEmis(res.data.emis || []);
//       } catch (err) {
//         setError("Failed to fetch EMI due report");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchEmis();
//   }, [filter]);

//   if (loading)
//     return <div className="EmiDueReport-loading">Loading EMI Report...</div>;
//   if (error) return <div className="EmiDueReport-error">{error}</div>;

//   // Pagination logic
//   const totalPages = Math.ceil(emis.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = emis.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () =>
//     currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // PDF Export
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(18);
//     doc.text("Company EMI Demand Sheet", 14, 20);

//     const tableColumn = [
//       "#",
//       "Customer Name",
//       "Loan Number",
//       "EMI Number",
//       "EMI Amount",
//       "Principal",
//       "Interest",
//       "Outstanding",
//       "Due Date",
//       "status",
//     ];

//     const tableRows = currentData.map((emi, index) => [
//       startIndex + index + 1,
//       emi.customerName,
//       emi.loanNumber,
//       emi.emiNumber,
//       emi.emiAmount,
//       emi.principalComponent,
//       emi.interestComponent,
//       emi.outstanding,
//       new Date(emi.dueDate).toLocaleDateString("en-IN"),
//       emi.status,
//     ]);

//     // ✅ Correct way in v3+ / v5+
//     autoTable(doc, {
//       startY: 30,
//       head: [tableColumn],
//       body: tableRows,
//       theme: "grid",
//       headStyles: { fillColor: [99, 102, 241], textColor: 255 },
//       styles: { fontSize: 10, cellPadding: 3 },
//     });

//     doc.save("EMI_Demand_Sheet.pdf");
//   };

//   return (
//     <div className="emi-due-report-wrapper">
//       <h1 className="emi-due-report-title">📋 EMI Due Report</h1>

//       {/* Filter buttons */}
//       <div className="emi-due-report-filters">
//         {["pending", "today", "upcoming"].map((f) => (
//           <button
//             key={f}
//             className={`emi-due-report-filter-btn ${filter === f ? "active" : ""}`}
//             onClick={() => {
//               setFilter(f);
//               setCurrentPage(1);
//             }}
//           >
//             {f.charAt(0).toUpperCase() + f.slice(1)}
//           </button>
//         ))}
//       </div>

//       {/* Controls: left rows selector, right PDF download */}
//       <div
//         className="emi-due-report-controls"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "16px",
//         }}
//       >
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="emi-due-report-filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       <div className="emi-due-report-table-container">
//         <table className="emi-due-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Customer Name</th>
//               <th>Loan Number</th>
//               <th>EMI Number</th>
//               <th>EMI Amount</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Outstanding</th>
//               <th>Due Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="10" className="emi-due-report-empty">
//                   ✅ No records found
//                 </td>
//               </tr>
//             ) : (
//               currentData.map((emi, index) => (
//                 <tr key={emi.id}>
//                   <td>{startIndex + index + 1}</td>
//                   <td>{emi.customerName}</td>
//                   <td>{emi.loanNumber}</td>
//                   <td>{emi.emiNumber}</td>
//                   <td>₹{emi.emiAmount.toLocaleString()}</td>
//                   <td>₹{emi.principalComponent.toLocaleString()}</td>
//                   <td>₹{emi.interestComponent.toLocaleString()}</td>
//                   <td>₹{emi.outstanding.toLocaleString()}</td>
//                   <td>{new Date(emi.dueDate).toLocaleDateString("en-IN")}</td>
//                   <td>
//                     <span
//                       className={`emi-due-report-status ${
//                         emi.status === "pending" ? "pending" : "paid"
//                       }`}
//                     >
//                       {emi.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination controls */}
//       <div className="emi-due-report-pagination">
//         <button
//           className="emi-due-report-pagination-btn"
//           onClick={handlePrev}
//           disabled={currentPage === 1}
//         >
//           ⬅ Prev
//         </button>
//         <span className="emi-due-report-pagination-info">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="emi-due-report-pagination-btn"
//           onClick={handleNext}
//           disabled={currentPage === totalPages}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default EmiDueReportTest;



// export default EmiDueReport;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import "./EmiDueReportTest.css";
// import { toast } from "react-toastify";


// const API_URL = "https://payyug.in/api";
// const EmiDueReportTest = () => {
//   const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;
//   const [emis, setEmis] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [filter, setFilter] = useState("pending"); // default filter

//   const [centers, setCenters] = useState([]);
//   const [selectedCenter, setSelectedCenter] = useState(null);
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [branchs, setBranchs] = useState([]);
//   const [selectedBranch, setSelectedBranch] = useState(null);
//   const [selectedStatus,setSelectedStatus]= useState("");


//   // Pagination logic
//   // const totalPages = Math.ceil(emis.length / rowsPerPage);
//   const [totalPages,setTotalPages]=useState(1);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   // const currentData = emis.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () =>
//     currentPage < totalPages && setCurrentPage(currentPage + 1);


//    /* ================= FETCH Branch ================= */
//   useEffect(() => {
//     const fetchBranch = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-branch`, {
//           params: {
//             SuperAdminId: localStorage.getItem("adminuserId"),
//             limit: "all",
//           },
//         });
//         // console.log("branch data", res.data);
//         setBranchs(res?.data.branches);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchBranch();
//   }, []);

//   // console.log("slected branch",selectedBranch?.id)
//   /* ================= FETCH CENTERS ================= */
//   useEffect(() => {
//     // if (!selectedBranch?.id) return;
//     const fetchCenters = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");
//         if (!superAdminId) return;

//         const res = await axios.get(`${API_URL}/group/centre`, {
//           params: {
//             superAdminId,
//             // branchid: selectedBranch?.id,
//           },
//         });

//         // console.log("center list", res.data?.data);

//         setCenters(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchCenters();
//   }, [selectedBranch]);

//   /* ================= FETCH GROUPS ================= */
//   useEffect(() => {
//     if (!selectedBranch?.id) return;
//     if (!selectedCenter?.id) return;

//     const fetchGroups = async () => {
//       try {
//         const superAdminId = localStorage.getItem("adminuserId");

//         const res = await axios.get(`${API_URL}/groupupdate/getall`, {
//           params: {
//             superAdminId,
//             CenterId: selectedCenter?.id,
//           },
//         });
//         setGroups(res.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchGroups();
//   }, [selectedCenter, selectedBranch]);

//   // PDF Export
  
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFontSize(18);
//     doc.text("Company EMI Demand Sheet", 14, 20);

//     const tableColumn = [
//       "#",
//       "Group Name",
//       "Loan Number",
//       "EMI Number",
//       "EMI Amount",
//       "Principal",
//       "Interest",
//       "Outstanding",
//       "Due Date",
//       "status",
//     ];

//     const tableRows = emis.map((emi, index) => [
//       startIndex + index + 1,
//       emi.loanAccount.groupName,
//       emi.loanAccount.loanAccountNumber,
//       emi.installmentNo,
//       emi.emiAmount,
//       emi.principalComponent,
//       emi.interestComponent,
//       emi.outstanding,
//       new Date(emi.dueDate).toLocaleDateString("en-IN"),
//       emi.status,
//     ]);

//     // ✅ Correct way in v3+ / v5+
//     autoTable(doc, {
//       startY: 30,
//       head: [tableColumn],
//       body: tableRows,
//       theme: "grid",
//       headStyles: { fillColor: [99, 102, 241], textColor: 255 },
//       styles: { fontSize: 10, cellPadding: 3 },
//     });

//     doc.save("EMI_Demand_Sheet.pdf");
//   };

//   const fetchEmis = async (page = 1, limit = rowsPerPage) => {
//     if (!selectedCenter) return;

//     try {
//       setLoading(true);
//       setError(null);

//       const res = await axios.get(
//         `${API_URL}/group-loan/emi/list-filter`,
//         {
//           params: {
//             superAdminId,
//             centerId: selectedCenter?.id,
//             // branchId: selectedBranch.id,
//             groupId: selectedGroup?.id,
//             filterType:selectedStatus==="all"?"":selectedStatus,
//             page,
//             limit,
//           },
//         }
//       );

//       setEmis(res.data?.data || []);
//       setTotalPages(res.data?.totalPages || 1);
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to fetch EMI report.");
//       setError("Failed to fetch EMI report.");
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedCenter) {
//       toast.error("Please select a Center before filtering.");
//       return;
//     }

//     setCurrentPage(1);
//     await fetchEmis(1, rowsPerPage);
//     toast.success("EMI report filtered successfully!");
//   };
 
//   useEffect(() => {
//     if (!selectedCenter) return;
//     fetchEmis(currentPage, rowsPerPage);
//   }, [currentPage, rowsPerPage]);

 

//   return (
//     <div className="emi-due-report-wrapper">
//       <h1 className="emi-due-report-title">📋 EMI Due Report</h1>

//       {/* Filter buttons */}
//       {/* <div className="emi-due-report-filters">
//         {["pending", "today", "upcoming"].map((f) => (
//           <button
//             key={f}
//             className={`emi-due-report-filter-btn ${filter === f ? "active" : ""}`}
//             onClick={() => {
//               setFilter(f);
//               setCurrentPage(1);
//             }}
//           >
//             {f.charAt(0).toUpperCase() + f.slice(1)}
//           </button>
//         ))}
//       </div> */}

//       <section className="pending-disbursal-filter-section">
//         <h2 className="pending-disbursal-title">Pending Disbursal Filter</h2>
//         <p className="pending-disbursal-sub-title">
//           Use filters to refine Emi due report
//         </p>
//         <form className="pending-disbursal-form" onSubmit={handleSubmit}>
//           <div className="pending-disbursal-grid">
//             {/* Branch */}
//             <div className="pending-disbursal-form-group">
//               <label>Select Branch</label>
//               <select
//                 value={selectedBranch?.id || ""}
//                 onChange={(e) => {
//                   const branch = branchs.find(
//                     (br) => br.id === Number(e.target.value)
//                   );
//                   setSelectedBranch(branch);
//                   setSelectedCenter(null); // reset
//                   setSelectedGroup(null); // reset
//                 }}
//               >
//                 <option value="">Select Branch</option>
//                 {branchs.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     {b.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Center */}
//             <div className="pending-disbursal-form-group">
//               <label>Select Center</label>
//               <select
//                 value={selectedCenter?.id || ""}
//                 disabled={!selectedBranch}
//                 onChange={(e) => {
//                   const center = centers.find(
//                     (cn) => cn.id === Number(e.target.value)
//                   );
//                   setSelectedCenter(center);
//                   // setSelectedGroup(null); // reset
//                 }}
//               >
//                 <option value="">Select Center</option>
//                 {centers.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.CenterName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Group */}
//             <div className="pending-disbursal-form-group">
//               <label>Select Group</label>
//               <select
//                 value={selectedGroup?.id || ""}
//                 disabled={!selectedBranch || !selectedCenter}
//                 onChange={(e) => {
//                   const group = groups.find(
//                     (gr) => gr.id === Number(e.target.value)
//                   );
//                   setSelectedGroup(group);
//                 }}
//               >
//                 <option value="">Select Group</option>
//                 {groups.map((g) => (
//                   <option key={g.id} value={g.id}>
//                     {g.groupname}
//                   </option>
//                 ))}
//               </select>
//             </div>
            
//             <div className="pending-disbursal-form-group">
//               <label>Select Status</label>
//               <select
//                 value={selectedStatus || ""}
//                  onChange={(e) => {
//                   setSelectedStatus(e.target.value);
//                 }}
//               >
//                 <option value="">Select Status</option>
//                 <option value="all">All</option>
//                 <option value="today">Today</option>
//                 <option value="tomorrow">Tomorrow</option>
//                 <option value="pending">Pending</option>
//                 <option value="overdue">OverDue</option>

//               </select>
//             </div>



//           </div>
//            <div className="filterbtnpdt">
//                <button type="submit" className="pending-disbursal-submit-btn">
//                     Apply Filter
//                </button>
                
//            </div>
//         </form>
//       </section>


//       {/* Controls: left rows selector, right PDF download */}
//       <div
//         className="emi-due-report-controls"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "16px",
//         }}
//       >
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="emi-due-report-filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       <div className="emi-due-report-table-container">
//         <table className="emi-due-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Group Name</th>
//               <th>Loan Number</th>
//               <th>EMI Number</th>
//               <th>EMI Amount</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Outstanding</th>
//               <th>Due Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {emis.length === 0 ? (
//               <tr>
//                 <td colSpan="10" className="emi-due-report-empty">
//                   ✅ No records found
//                 </td>
//               </tr>
//             ) : (
//               emis.map((emi, index) => (
//                 <tr key={emi.id}>
//                   <td>{startIndex + index + 1}</td>
//                   <td>{emi.loanAccount.groupName}</td>
//                   <td>{emi.loanAccount.loanAccountNumber}</td>
//                   <td>{emi.installmentNo}</td>
//                   <td>₹{emi.emiAmount.toLocaleString()}</td>
//                   <td>₹{emi.principalComponent.toLocaleString()}</td>
//                   <td>₹{emi.interestComponent.toLocaleString()}</td>
//                   <td>₹{emi.outstanding.toLocaleString()}</td>
//                   <td>{new Date(emi.dueDate).toLocaleDateString("en-IN")}</td>
//                   <td>
//                     <span
//                       className={`emi-due-report-status ${
//                         emi.status === "pending" ? "pending" : "paid"
//                       }`}
//                     >
//                       {emi.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination controls */}
//       <div className="emi-due-report-pagination">
//         <button
//           className="emi-due-report-pagination-btn"
//           onClick={handlePrev}
//           disabled={currentPage === 1}
//         >
//           ⬅ Prev
//         </button>
//         <span className="emi-due-report-pagination-info">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="emi-due-report-pagination-btn"
//           onClick={handleNext}
//           disabled={currentPage === totalPages}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default EmiDueReportTest;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "./EmiDueReportTest.css";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const EmiDueReportTest = () => {
  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  const [emis, setEmis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
    const [company, setCompany] = useState(null);


  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  const [totalPages, setTotalPages] = useState(1);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const [loanType, setLoanType] = useState("");

  const handlePrev = () => currentPage > 1 && setCurrentPage((p) => p - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage((p) => p + 1);


    useEffect(() => {
      const fetchCompany = async () => {
        try {
          setLoading(true);
          const response = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
          );
          const data = await response.json();
  
          if (response.ok && data) {
            // Dynamically construct logo URL
            if (data.logo) {
              data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
            }
            setCompany(data);
          } else {
            console.error("Failed to fetch company data");
          }
        } catch (err) {
          console.error("Error fetching company details:", err);
        } finally {
          setLoading(false);
        }
      };
  
      if (superAdminId) fetchCompany();
    }, [ superAdminId]);

  /* ================= FETCH Branch ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "10000",
          },
        });
        setBranchs(res?.data?.branches || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load branches");
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    if (!selectedBranch?.id) {
      setCenters([]);
      setSelectedCenter(null);
      return;
    }

    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch.id,
            limit: "10000",
          },
        });

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load centers");
      }
    };

    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedBranch?.id || !selectedCenter?.id) {
      setGroups([]);
      setSelectedGroup(null);
      return;
    }

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId: selectedCenter.id,
          },
        });

        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load groups");
      }
    };

    fetchGroups();
  }, [selectedCenter, selectedBranch]);
  


  /* ================= FETCH EMIS ================= */
  const fetchEmis = async (page = 1, limit = rowsPerPage) => {
    if (!selectedCenter ) return;
    if(!selectedGroup) return ;

    try {
      setLoading(true);
      setError(null);

      const res = await axios.get(`${API_URL}/group-loan/emi/list-filter`, {
        params: {
          superAdminId,
          centerId: selectedCenter.id,
          groupId: selectedGroup?.id || "",
          filterType: selectedStatus === "all" ? "" : selectedStatus,
          loanType: loanType,
          page,
          limit: "10000",
        },
      });

      setEmis(res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch EMI report.");
      setError("Failed to fetch EMI report.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= SUBMIT FILTER ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCenter) {
      toast.error("Please select a Center before filtering.");
      return;
    }

    if (!selectedGroup) {
      toast.error("Please select a Group before filtering.");
      return;
    }

    setCurrentPage(1);
    await fetchEmis(1, rowsPerPage);
    toast.success("EMI report filtered successfully!");
  };

  /* ================= PAGINATION FETCH ================= */
  useEffect(() => {
    if (!selectedCenter) return;
    fetchEmis(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage]);


    const handleDownloadPDF = async() => {
      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
  
      // ================= LOGO =================
      const logoX = 15;
      const logoY = 12;
      const logoSize = 25;
      const logoPadding = 2;
  
      // Border color & thickness
      doc.setDrawColor(0);
      doc.setLineWidth(0.2);
  
      // Calculate center of logo
      const centerX = logoX + logoSize / 2;
      const centerY = logoY + logoSize / 2;
  
      // Radius = half of logo + padding
      const radius = logoSize / 2 + logoPadding;
  
      // Draw circle
      doc.circle(centerX, centerY, radius);
  
      // Logo image
      if (company?.logoUrl) {
        try {
          const logoResp = await fetch(company.logoUrl);
          const logoBlob = await logoResp.blob();
          const reader = new FileReader();
          await new Promise((resolve) => {
            reader.onload = () => {
              doc.addImage(
                reader.result,
                "PNG",
                logoX,
                logoY,
                logoSize,
                logoSize,
              );
              resolve();
            };
            reader.readAsDataURL(logoBlob);
          });
        } catch {
          // silent fail
        }
      }
  
      // ================= COMPANY NAME (AUTO WRAP) =================
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
  
      const nameX = logoX + logoSize + 5;
      const nameY = 18;
      const nameMaxWidth = pageWidth - nameX - 15;
  
      const companyNameText = doc.splitTextToSize(
        (company?.name || "COMPANY NAME").toUpperCase(),
        nameMaxWidth,
      );
  
      doc.text(companyNameText, nameX, nameY);
  
      // Calculate Y after company name
      let currentY = nameY + companyNameText.length * 6;
  
      // ================= COMPANY DETAILS =================
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
  
      const detailX = nameX;
      const detailMaxWidth = nameMaxWidth;
  
      // Address
      const addressText = doc.splitTextToSize(
        company?.address || "Company Address",
        detailMaxWidth,
      );
      doc.text(addressText, detailX, currentY);
      currentY += addressText.length * 5;
  
      // Email
      const emailText = doc.splitTextToSize(
        `Email: ${company?.email || "-"}`,
        detailMaxWidth,
      );
      doc.text(emailText, detailX, currentY);
      currentY += emailText.length * 5;
  
      // Phone
      const phoneText = doc.splitTextToSize(
        `Phone: ${company?.contact || "-"}`,
        detailMaxWidth,
      );
      doc.text(phoneText, detailX, currentY);
      currentY += phoneText.length * 5;
  
      // Divider
      doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

          // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Emi Due Report", pageWidth / 2, currentY + 14, {
      align: "center",
    });

    const tableColumn = [
      "#",
      "Group Name",
      "Loan Number",
      "EMI Number",
      "EMI Amount",
      "Principal",
      "Interest",
      "Outstanding",
      "Due Date",
      "Status",
    ];

    const tableRows = emis.map((emi, index) => [
      startIndex+index + 1,
      emi.loanAccount?.groupName || "-",
      emi.loanAccount?.loanAccountNumber || "-",
      emi.installmentNo ?? "-",
      emi.emiAmount ?? 0,
      emi.principalComponent ?? 0,
      emi.interestComponent ?? 0,
      emi.outstanding ?? 0,
      emi.dueDate ? new Date(emi.dueDate).toLocaleDateString("en-IN") : "-",
      emi.status || "-",
    ]);

       autoTable(doc, {
         startY: currentY + 20,
         head: [tableColumn],
         body: tableRows,
   
         theme: "grid",
         styles: {
           fontSize: 7,
           cellPadding: 3,
           halign: "center",
         },
         headStyles: {
           fontStyle: "bold",
           fontSize: 7,
         },
         alternateRowStyles: {
           fillColor: [245, 245, 245],
         },
   
         didDrawPage: function () {
           const pageWidth = doc.internal.pageSize.width;
           const pageHeight = doc.internal.pageSize.height;
   
           doc.setDrawColor(0);
           doc.setLineWidth(0.2);
   
           // Page border on EVERY page
           doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
         },
       });
   
       // ================= FOOTER =================
       const pageCount = doc.internal.getNumberOfPages();
       for (let i = 1; i <= pageCount; i++) {
         doc.setPage(i);
         doc.setFontSize(8);
         doc.setTextColor(100);
         doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
         doc.text("Generated by Collection System", 14, pageHeight - 10);
       }
   

    doc.save("Emi_Due_Report.pdf");
  };

  return (
    <div className="emi-due-report-wrapper">
      <h1 className="emi-due-report-title">📋 EMI Due Report</h1>

      <section className="pending-disbursal-filter-section">
        {/* <h2 className="pending-disbursal-title">Pending Disbursal Filter</h2>
        <p className="pending-disbursal-sub-title">
          Use filters to refine EMI due report
        </p> */}

        <form className="pending-disbursal-form" onSubmit={handleSubmit}>
          <div className="pending-disbursal-grid">
            {/* Branch */}
            <div className="pending-disbursal-form-group">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value)
                  );
                  setSelectedBranch(branch || null);
                  setSelectedCenter(null);
                  setSelectedGroup(null);
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Center */}
            <div className="pending-disbursal-form-group">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const center = centers.find(
                    (cn) => cn.id === Number(e.target.value)
                  );
                  setSelectedCenter(center || null);
                  setSelectedGroup(null);
                }}
              >
                <option value="">Select Center</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Group */}
            <div className="pending-disbursal-form-group">
              <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedBranch || !selectedCenter}
                onChange={(e) => {
                  const group = groups.find(
                    (gr) => gr.id === Number(e.target.value)
                  );
                  setSelectedGroup(group || null);
                }}
              >
                <option value="">Select Group</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>

            {/* Status */}
            <div className="pending-disbursal-form-group">
              <label>Select Status</label>
              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                <option value="all">All</option>
                <option value="today">Today</option>
                <option value="tomorrow">Tomorrow</option>
                <option value="pending">Pending</option>
                <option value="overdue">OverDue</option>
              </select>
            </div>
            <div className="pending-disbursal-form-group">
              <label>Loan Type</label>
              <select
                value={loanType}
                onChange={(e) => {
                const val = e.target.value;
                setLoanType(val);
              }}
              >
                <option value="">Select Loan Type</option>
                <option value="FIXED">Fixed</option>
                <option value="INDIVIDUAL">Individual</option>
              </select>
            </div>
          </div>

          <div className="filterbtnpdt">
            <button type="submit" className="pending-disbursal-submit-btn">
              Apply Filter
            </button>
          </div>
        </form>
      </section>

      {/* Controls */}
      <div
        className="emi-due-report-controls"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>{" "}
          entries
        </label>

        <button
          className="emi-due-report-filter-btn"
          onClick={handleDownloadPDF}
        >
          📄 Download PDF
        </button>
      </div>

      {/* Table */}
      <div className="emi-due-report-table-container">
        <table className="emi-due-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Group Name</th>
              <th>Loan Number</th>
              <th>EMI Number</th>
              <th>EMI Amount</th>
              <th>Principal</th>
              <th>Interest</th>
              <th>Outstanding</th>
              <th>Due Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {emis.length === 0 ? (
              <tr>
                <td colSpan="10" className="emi-due-report-empty">
                  ✅ No records found
                </td>
              </tr>
            ) : (
              emis.map((emi, index) => (
                <tr key={emi.id || index}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{emi.loanAccount?.groupName ||"N/A"}</td>
                  <td>{emi.loanAccount?.loanAccountNumber ||"N/A"}</td>
                  <td>{emi.installmentNo ||"N/A"}</td>
                  <td>{`₹${(emi.emiAmount ?? 0).toLocaleString()}`||"N/A"}</td>
                  <td>{`₹${(emi.principalComponent ?? 0).toLocaleString()}`||"N/A"}</td>
                  <td>{`₹${(emi.interestComponent ?? 0).toLocaleString()}`||"N/A"}</td>
                  <td>{`₹${(emi.outstanding ?? 0).toLocaleString()}`||"N/A"}</td>
                  <td>
                    {emi.dueDate
                      ? new Date(emi.dueDate).toLocaleDateString("en-IN")
                      : "-"}
                  </td>
                  <td>
                    <span
                      className={`emi-due-report-status ${
                        emi.status === "pending" ? "pending" : "paid"
                      }`}
                    >
                      {emi.status || "-"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="emi-due-report-pagination">
        <button
          className="emi-due-report-pagination-btn"
          onClick={handlePrev}
          disabled={currentPage === 1}
        >
          ⬅ Prev
        </button>
        <span className="emi-due-report-pagination-info">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className="emi-due-report-pagination-btn"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default EmiDueReportTest;

